import React, { Component } from 'react';
import classNames from 'classnames';
import IconComponent from '../../iconComponent';
import MenuItem from './menuItem';
import styles from './style.scss';

export default class SideBarContainer extends Component {
        
    render() {
        return (
            <div className={classNames(styles.portalMainSideMenu)}>
                <div className={classNames(styles.menuIcons)}>
                    <div>
                        <IconComponent iconClassName={classNames(['cx-logo-icon'])} />
                    </div>
                    <ul>
                        <MenuItem iconClassName={classNames(['user-settings-icon'])} />
                    </ul>
                    {this.props.children}
                </div>
            </div>
        );
    }
}